<template>
  <div>
      <!-- 导航栏 -->
      <div id="headers">
          <img src="../../assets/images/img_31.png" alt="" @click="returnPage" id="returns">
          <div class="headerText">电签</div>
      </div>  
      <!-- 信息 --> 
        <div class="content_wrap">
        <div class="input_wrap">
            <h4 >姓名</h4>
            <input v-model="Name" type="text" placeholder="请填写您的姓名" >
        </div>
        <div class="input_wrap">
            <h4>手机号</h4>
            <input v-model="phNum" type="text" placeholder="请填写您的手机号" >
        </div>
        <div class="input_wrap">
            <h4 class="content_h4">身份证号</h4>
            <input v-model="IdCard" type="text" placeholder="请填写您的身份证号" >
        </div> 
        <div class="input_wrap">
            <h4>支付宝账号</h4>
            <input v-model="AlipayNum" type="text" placeholder="请输入您的支付宝账号" >
        </div>  
        </div>
      <div class="btn" @click="submit">提交</div>
      <van-popup v-model="show" position="bottom">
        <div class="box">
          <div class="box-wz">
            <div class="box-wz-yuan">
              <span></span>
            </div>
            <div class="box-wzs">
              本人自愿同意签署<a @click="toUserAgreement"><i>《钱大师打款服务协议》</i></a>，由安阳资猫信息技术有限公司提供的打款服务
            </div>
            </div>
        <div class="box-yz">
          <input type="number" placeholder="请输入验证码" v-model="captcha">
          <div class="box-yz-m" v-show="djs" @click="getCode">获取验证码</div>
          <div class="box-yz-m box-yz-ms" v-show="!djs">{{count}} s</div>
        </div>
        <div class="sure" @click="sure">确认</div>
        </div>
      </van-popup>
  </div>

</template>

<script>
  import { Dialog ,Popup} from 'vant';
export default {
  data () {
    return {
      Name:'',
      phNum:'',
      IdCard:'',
      AlipayNum:'',
      show:false,//下面的弹窗
      djs: true, //是否显示倒计时
      count: '',
      timer: null,
      captcha:null,//验证码
    }
  },
  methods: {
  // 返回按钮
    returnPage(){
      this.$router.go(-1);
  },
  toUserAgreement() {
    this.$router.push('/personal/noviceGuide/userAgreement');
  },
  // 提交 
  submit(){
    if(this.Name ===''){
    Dialog.alert({ title: '提示',message: '请输入姓名' })
    return ;
    }
    if(this.phNum ===''){
    Dialog.alert({ title: '提示',message: '请输入手机号' })
    return ;
    }
    if(this.IdCard ===''){
    Dialog.alert({ title: '提示',message: '请输入身份证号' })
    return ;
    }
    if(this.AlipayNum ===''){
    Dialog.alert({ title: '提示',message: '请输入支付宝账号' })
    return ;
    }
    let param = {
    name:this.Name,
    mobile:this.phNum,
    identity:this.IdCard,
    alipayAccountNo:this.AlipayNum
    }
    this.$http.POSTS('tuser_cash/synUserInfo',param,(res)=>{
    this.$loading(false);
    if(res.flag === 'error'){
    Dialog.alert({
    title: '提示',
    message: res.msg,
    })
    return ;
    }
    this.show = true
    })
    
  },
  // 获取验证码 
 getCode(){
    this.countdown()
    const param = {}
    this.$http.POSTS('tuser_cash/codeNumber',param,(res)=>{
      this.$loading(false);
      if(res.flag === 'error'){
        Dialog.alert({
          title: '提示',
          message: res.msg,
        }).then(()=>{
          this.djs = true 
          this.timer = null
        })
        return ;
      }else{
        if(res.data.success === 1) {
          this.$toast('验证码发送成功，请注意查收')
        }else {
            this.$toast(res.msg)
            this.$router.push('/')
        }
      }
    })
} ,
// 60s倒计时 
countdown(){
  const TIME_COUNT = 60;
  if (!this.timer) {
  this.count = TIME_COUNT;
  this.djs = false;
  this.timer = setInterval(() => {
  if (this.count > 0 && this.count <= TIME_COUNT) {
  this.count--;
  } else {
  this.djs = true;
  clearInterval(this.timer);
  this.timer = null;
  }
  }, 1000)
  }
},
// 提交验证码 
sure(){
    if(!this.captcha){
    Dialog.alert({title: '提示', message: '请输入验证码', })
    return ;
    }
    const params = {captcha:this.captcha }
    this.$http.POSTS('tuser_cash/validateCode',params,(res)=>{
      this.$loading(false);
      if(res.flag === 'error'){
        Dialog.alert ({
          title: '提示',
          message: res.msg,
        }).then(()=>{
          this.show = false ;
        })
        return ;
      }
      // 最后成功给一个弹窗
      Dialog.alert({
        title: '提示',
        message: '签署成功,请耐心等待签约结果,再尝试提现',
      }).then(()=>{
        this.show = false ;
        this.$router.push('/')
      })
    })
}
  }
}
</script>

<style lang='less' scoped>
    #headers{
      width: 375px;
      height: 45px;
      background: linear-gradient(to right,#EB3F47,#E50113);
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      #returns{
          width: 11px;
          height: 18px;
          position: absolute;
          left: 15px;
          padding: 0 3px;
      }
      .headerText{
          font-size: 15px;
          color: #FFFFFF;
            }
        }
     .content_wrap{
      box-shadow:0px 0px 0px 0px rgba(229,229,229,1);
      margin:15px;
      box-sizing: border-box;
      background: white;
      border-radius:5px;
      overflow: hidden;
       
      >.input_wrap:nth-last-child(1){
        border:none;
    }
     .input_wrap{
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius:2px;    
        box-sizing: border-box;
        height: 50px;
        border-bottom: 1px solid #E5E5E5;
      h4 {
        margin-left: 15px;
        font-size:16px;
        font-family:PingFangSC-Regular;
        color:rgba(51,51,51,1);
        line-height:16px; 
        width: 80px;;
      }
      input {
        display: inline-block;
        flex: 1;
        background:none;outline:none;appearance:none;
        outline-style: none;
        border: none;
        -moz-appearance:none;
        -webkit-appearance:none;
        height: 50px;
        padding: 0 15px;
        font-size:13px;
        font-weight:400;
        color:rgba(21,21,21,1);
        line-height:17px;
        text-align: right;
      }
      // input::-webkit-input-placeholder{
      //     text-align: right;
      //     }
    }
  }   
 .btn {
  display: flex;
  justify-content: center;
  align-items: center;
  height:50px;
  background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
  box-shadow:0px 5px 10px 0px rgba(229,1,19,0.15);
  border-radius:25px;
  margin:32px 20px 48px 20px;
  font-size:15px;
  font-weight:500;
  color:rgba(255,255,255,1);
  line-height:15px;
 }
 /deep/ .van-popup{
   border-radius:5px 5px 0px 0px !important;
 }
 .box {
   display:flex;
   flex-direction: column ;
   align-items: center;
   padding: 32px 20px ;
   .box-wz {
     width: 100%;
     display: flex;
    .box-wz-yuan {
      display: flex;
      justify-content: center;
      align-items: center;
      width:16px;
      height:16px;
      border-radius: 50%;
      border:1px solid rgba(230,7,24,1);
      box-sizing: border-box;
      >span {
        display: inline-block;
        width:10px;
        height:10px;
        border-radius: 50%;
        background:rgba(233,45,56,1);
      }
    }
    .box-wzs {
      box-sizing: border-box;
      width:304px;
      height:48px;
      font-size:15px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      padding: 0 14px;
      color:rgba(51,51,51,1);
      i {
        font-style: normal;
        color: #E50617;
      }
    }
   }
   .box-yz {
    display: flex;
    width: 100%;
    justify-content:space-between;
    align-items: center;
    height:50px;
    border-bottom: 1px solid rgba(222,222,222,1);
    padding-top: 24px;
     input {
        display: inline-block;
        flex: 1;
        background:none;outline:none;appearance:none;
        outline-style: none;
        border: none;
        -moz-appearance:none;
        -webkit-appearance:none;
        font-size:13px;
        font-weight:400;
        color:rgba(21,21,21,1);
        line-height:17px;
      }
      .box-yz-m {
       width:100px;
        height:32px;
        background:rgba(255,255,255,0.6);
        border-radius:20px;
        border:1px solid rgba(229,1,19,1);
        font-size:15px;
        font-weight:400;
        color:rgba(229,1,19,1);
        line-height:32px;
        text-align: center;
      }
      .box-yz-ms {
         border:1px solid #666;
        color: rgb(125, 139, 141);
      }
   }
   .sure {
     width:335px;
      height:50px;
      background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
      box-shadow:0px 5px 10px 0px rgba(229,1,19,0.15);
      border-radius:25px;
      font-size:15px;
      font-weight:500;
      color:rgba(255,255,255,1);
      line-height:50px;
      text-align: center;
      margin-top: 32px;
   }
 }


</style>